import ApiTokenViewer from './components/ApiTokenViewer'
import AvatarSelector from './components/AvatarSelector'
import CheckAll from './components/CheckAll'
import ConfirmClick from './components/ConfirmClick'
import DateTimePicker from './components/DateTimePicker'
import Ellipsis from './components/Ellipsis'
import ExternalLink from './components/ExternalLink'
import FileInput from './components/FileInput'
import FontPicker from './components/FontPicker.js'
import GamifiedVideoSelect from './components/GamifiedVideoSelect'
import GamifiedVideoHandler from './components/GamifiedVideoHandler'
import IframeGenerator from './components/IframeGenerator'
import Identifier from './components/Identifier'
import MessageBox from './components/MessageBox'
import ModuleNavigation from './components/ModuleNavigation'
import MultiSelect from './components/MultiSelect.js'
import OpenLinksInNewTab from './components/OpenLinksInNewTab'
import PasswordStrengthMeter from './components/PasswordStrengthMeter'
import Popover from './components/Popover'
import RangeSlider from './components/RangeSlider'
import RepeaterFields from './components/RepeaterFields'
import RichMessageBox from './components/RichMessageBox'
import SkipFirstRow from './components/SkipFirstRow'
import SortOrder from './components/SortOrder'
import Tooltip from './components/Tooltip'
import VuplexCommunicator from './components/VuplexCommunicator'
import Chart from './components/Chart'
import ClickableTableRow from './components/ClickableTableRow'
import SubmitClick from './components/SubmitClick'
import Lightbox from './components/Lightbox'
import LeagueChart from './components/LeagueChart'
import MatchingUsers from './components/MatchingUsers'
import ToggleState from './components/ToggleState'
import SelectState from '@/components/SelectState'
import * as bootstrap from 'bootstrap'
import ClipboardJS from 'clipboard'
import EmailRequest from '@/components/EmailRequest'
import internalApi from '@/utils/internalApi'

document.addEventListener('DOMContentLoaded', function () {
    ApiTokenViewer.initAll('.gp-api-token-viewer')
    AvatarSelector.initAll('.gp-avatar-select')
    CheckAll.initAll('.gp-check-parent')
    ConfirmClick.initAll('.gp-confirm-click')
    ClickableTableRow.initAll('.gp-row-click')
    DateTimePicker.initAllDatePicker('.js-datepicker')
    DateTimePicker.initAllTimePicker('.js-timepicker')
    DateTimePicker.initAllDateTimePicker('.js-datetimepicker')
    Ellipsis.initAll('.gp-dropdown-ellipsis')
    FileInput.initAll('input[type="file"]')
    FontPicker.initAll('.gp-font-picker')
    GamifiedVideoSelect.initAll('.gp-gamified-video-select')
    GamifiedVideoHandler.init('.gp-gamified-video-player')
    Identifier.initAll('.gp-identifier')
    IframeGenerator.init('.gp-iframe-code')
    MessageBox.initAll('.gp-message')
    ModuleNavigation.initAll('.gp-module-navigation')
    MultiSelect.initAll('.gp-multiselect')
    Popover.initAll('[data-bs-toggle="popover"]')
    RichMessageBox.initAll('.gp-rich-message')
    OpenLinksInNewTab.initAll('.gp-target-blank')
    PasswordStrengthMeter.initAll('.gp-password')
    RangeSlider.initAll('.gp-slider')
    RepeaterFields.initAll('.gp-repeater')
    SkipFirstRow.initAll('.gp-skip-first-row')
    SortOrder.initAll('.gp-draggable')
    SubmitClick.initAll('.gp-submit-click')
    Tooltip.initAll('[data-bs-toggle="tooltip"]')
    Chart.initAll('[data-chart]')
    Lightbox.initAll('[data-gp-lightbox]')
    LeagueChart.initAll('.gp-league-chart')
    MatchingUsers.initAll('.gp-matching-users')
    ToggleState.initAll('.gp-toggle-state')
    SelectState.initAll('.gp-select-state')
    ExternalLink.initAll('a')
    EmailRequest.initAll('.gp-email-request')

    new ClipboardJS('.clipboard')
})

window.vuplexCommunicator = new VuplexCommunicator(process.env.MIX_APP_ENV === 'local')

window.bootstrap = bootstrap

window.internalApi = internalApi

import defaultTranslations from './translations'

window.translations = defaultTranslations
